module.exports = __webpack_public_path__ + "img/shouquan.373c83d0.png";